export default __webpack_public_path__ + "static/media/food-menu1.1d5f463a.jpeg";